module.exports = __webpack_public_path__ + "img/8-1_07.3f67d39a.jpg";